var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloudUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "cloud-upload") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#f2f6fb",
    d: "M32 16c0 8.837-7.163 16-16 16s-16-7.163-16-16c0-8.837 7.163-16 16-16s16 7.163 16 16z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#0057b8",
    d: "M18.329 17.28l-2.329-2.329-2.329 2.329 0.373 0.373 1.689-1.671v5.884h0.533v-5.884l1.689 1.671z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#0057b8",
    d: "M19.698 13.333c-0.249-1.813-1.831-3.2-3.698-3.2-2.062 0-3.733 1.671-3.733 3.733v0.267h-0.142c-1.262 0-2.311 0.924-2.507 2.133h-0.036v2.933h4.267v-0.533h-3.716v-2.116c0.053-1.049 0.942-1.884 1.991-1.884h0.676v-0.8c0-1.76 1.44-3.2 3.2-3.2 1.671 0 3.076 1.298 3.2 2.951l0.036 0.249h0.249c1.316 0 2.382 1.067 2.382 2.4s-1.084 2.4-2.4 2.4h-1.333v0.533h1.333c1.618 0 2.933-1.316 2.933-2.933 0.018-1.547-1.173-2.809-2.702-2.933z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudUpload);
export default __webpack_public_path__ + "static/media/cloud-upload.4e35992be20b2931ab2984daf6628e0a.svg";
export { ForwardRef as ReactComponent };